var ensureDateString = require('./ensure-date-string')
var format = require('date-fns/format')
var FORMATS = require('../constants/date-formats')
// supported locales
var es = require('date-fns/locale/es')
var fr = require('date-fns/locale/fr')
var br = require('date-fns/locale/pt')
var zh_cn = require('date-fns/locale/zh_cn')
var hi = require('./_locales/hi')

var dateUtils = require('./date-utils').utils

var locales = {
  'zh-CN': zh_cn,
}

function getLocale(locale) {
  if (/^es/.test(locale)) return es
  if (/^fr/.test(locale)) return fr
  if (/^hi/.test(locale)) return hi
  if (/^pt/.test(locale)) return br
  return locales[locale]
}

function needsTimezone(format) {
  return (
    /^(?:TIME_SHORT|DATETIME)/.test(format) && !/(?:NOTZ|ISO)/g.test(format)
  )
}
// pt-BR local Format String
function getPtBrFormatStr(formatStr) {
  // for datFormat: DATE_ALPHA_SHORT
  var formatPtBRStr = 'DD [de] MMM [de] YYYY'
  // for datFormat: DATE_ALPHA_LONG
  var formatPtBRlongStr = 'DD [de] MMMM [de] YYYY'
  // This format is meant to represent the Short format of the locale
  if (formatStr === 'DATE_ALPHA_SHORT') {
    return formatPtBRStr
    // This format is meant to represent the Long format of the locale
  } else if (formatStr === 'DATE_ALPHA_LONG') {
    return formatPtBRlongStr
  } else {
    return FORMATS[formatStr.replace(/_NOTZ/, '')] || formatStr
  }
}

/**
 * Formats dates/times in a set of canned formats.
 * @param {string} value A date (string or object)
 * @param {string} formatStr A canned date format (eg DATE_ALPHA_MONTH, DATE_NUMERIC_STANDARD)
 * @param {object} config Configuration object.
 * @param {string} [config.locale] A locale in hyphen format (eg en-US)
 * @param {object} [config.timezone] Timezone object with at least one key: `abbreviation` (needed for some formats)
 * @returns {string} Formatted date
 */
function dateTime(value, formatStr, config) {
  // need to strip tz info from dates
  // to prevent casting the date to browser's tz
  var dateStr = ensureDateString(value).replace(
    /(?:\+|-)(?:\d{4}|\d{2}:\d{2})$/,
    ''
  )

  // This format is meant to represent the standard format of the locale
  if (formatStr === 'DATE_NUMERIC_STANDARD') {
    formatStr = dateUtils[config.locale].format
  }

  // if we need to display the timezone (eg GMT), need to use the one from config
  var needsTz = needsTimezone(formatStr)
  var formattedValue = format(
    dateStr,
    //Set date format for 'pt-BR' locale
    ['pt-BR'].includes(config.locale)
      ? getPtBrFormatStr(formatStr)
      : FORMATS[formatStr.replace(/_NOTZ/, '')] || formatStr,
    {
      locale: getLocale(config.locale),
    }
  )
  // bail on valid dates
  if (formattedValue === 'Invalid Date') return ''

  return needsTz
    ? formattedValue + ' ' + config.timezone.abbreviation
    : formattedValue
}

module.exports = dateTime
